import { DollarOutlined, StarOutlined, WalletOutlined } from '@ant-design/icons'
import { MobileHeader } from '@widgets/mobile-header'
import { Space, Typography } from 'antd'
import type { ReactNode } from 'react'

interface AdPostingMobileHeaderProps {
    title: string
    titleIcon?: ReactNode
    current: string
    filter: ReactNode
}

const { Text } = Typography

export const AdPostingMobileHeader = ({ title, current, titleIcon, filter }: AdPostingMobileHeaderProps) => {
    const pages = [
        {
            name: 'partners',
            url: '/advertising/partners',
            title: (
                <Space>
                    <StarOutlined style={{ fontSize: '17px' }} />
                    <Text style={{ fontSize: '17px', fontWeight: 500 }}>Партнеры</Text>
                </Space>
            )
        },
        {
            name: 'purchase',
            url: '/advertising/buy',
            title: (
                <Space>
                    <WalletOutlined style={{ fontSize: '17px' }} />
                    <Text style={{ fontSize: '17px', fontWeight: 500 }}>Закуп</Text>
                </Space>
            )
        },
        {
            name: 'sale',
            url: '/advertising/sell',
            title: (
                <Space>
                    <DollarOutlined style={{ fontSize: '17px' }} />
                    <Text style={{ fontSize: '17px', fontWeight: 500 }}>Продажа</Text>
                </Space>
            )
        }
    ]

    return (
        <MobileHeader
            pages={pages}
            title={title}
            titleIcon={titleIcon}
            current={current}
            dropdownKey="ad-posting-page"
            filter={filter}
        />
    )
}
